<div class="card card-plain" *ngIf="shouldShowHistorySection">
	<div class="card-header" role="tab" id="headingReviewApprovalHistory">
		<a
			[attr.data-toggle]="useAngularToggle ? null : 'collapse'"
			[attr.data-parent]="useAngularToggle ? null : '#accordion'"
			href="#collapseReviewApprovalHistory"
			data-testid="review-history-toggle"
			[attr.aria-expanded]="useAngularToggle ? expanded : false"
			aria-controls="collapseReviewApprovalHistory"
			(click)="toggleHistory($event)"
		>
			<h5>
				Review Comments &amp; Approval History ({{ reviewHistoryEntries.length }})
				<i class="nc-icon nc-minimal-down"></i>
			</h5>
		</a>
	</div>
	<div
		id="collapseReviewApprovalHistory"
		class="collapse"
		[class.show]="useAngularToggle && expanded"
		role="tabpanel"
		aria-labelledby="headingReviewApprovalHistory"
	>
		<div class="card-body">
			<app-review-comments-approval-history
				[form]="form"
				[wrapInCard]="false"
				[showHeading]="false"
			></app-review-comments-approval-history>
		</div>
	</div>
</div>
